module.exports = __webpack_public_path__ + "static/media/apolloDesktop.99b8d816.png";